
import DynamicSectionElement from '@/scripts/dynamic-section-element.js'
import KeenSlider from "keen-slider";
class Cart extends DynamicSectionElement{
  constructor(){
    super()
    this.selectors = {
      cartForm:'[action="/cart"]',
      emptyCart : '[data-role="empty-cart"]',
      itemGrid:'[data-role="cart-item-grid"]',
      cartSummarry:'[data-role="cart-summary"]'
    }
     // debounce inputs change
     function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
    this.form = this.querySelector(this.selectors.cartForm);
    this.debouncedOnSubmit = (event) =>{
      // debounce is removed as per requirement
      this.onQuantityUpdate(event);
    }
    document.addEventListener('change-quantity',this.debouncedOnSubmit.bind(this));
    /// item remove
    document.addEventListener('remove-itemConfirm',(e)=>{
      this.updateQuantity(e.detail.key,0,"Product removed from shopping bag");
    })
    // mini cart item remove
    document.addEventListener("mini-item-removed",(e)=>{
      this.updateQuantity(e.detail.key,0);
    })
  }
  attributeChangedCallback(){
    console.log("attribute update")
  }
  onQuantityUpdate = (e) => {
    e.preventDefault();
    let quantity = e.target.value;
    let key = e.target.closest('cart-item').dataset.key;
    this.updateQuantity(key,quantity)
  }
  // quantity update handle
  updateQuantity = (key,quantity,message) =>{
    this.classList.add('loading');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        updates: { [key]: quantity },
        sections: this.dataset.section
      })
    }).then(res => res.json())
    .then(data => {
      POPUPS.Cart.updateMiniCart();
      this.updateSection.bind(this,data.sections[this.dataset.section])();
      setTimeout(()=>{
        this.qtyUpdateNofication.bind(this)(message);
      },0)
    })
  }

  //cart item quantity update notification
  qtyUpdateNofication(message){
    message ? document.querySelector('[data-role="cart-update-notification"]').innerText = message : "";
    let timeout;
    let form = this.querySelector(this.selectors.cartForm);
    form?.classList.add('success');
    clearTimeout(timeout);
    setTimeout(()=>{
      form?.classList.remove('success');
    },1500)
  }
  // rerender section
  updateSection = (sectionString) =>{
    let parser = new DOMParser();
    let cartHtml = parser.parseFromString(sectionString,"text/html");
    let isEmpty = cartHtml.querySelector(this.selectors.emptyCart);
    // updating form
    document.querySelector("shopify-cart").innerHTML = cartHtml.querySelector("shopify-cart").innerHTML;
    this.classList.remove('loading');
    // init slider for you may also like
    initSlider();
  }
}
customElements.define('shopify-cart',Cart);

// cart remove button
class RemoveBtn extends HTMLElement{
  constructor(){
    super()
    this.itemKey = this.closest('cart-item')?.dataset.key;
    this.productHandle = this.closest('cart-item')?.dataset.producthandle;
    this.productId = this.closest('cart-item')?.dataset.productid;
    this.variantId = this.closest('cart-item')?.dataset.variantid;
    this.addEventListener('click',(e)=>{
      e.preventDefault();
      let removeEvent = new CustomEvent('remove-item', { detail: {key:this.itemKey,handle:this.productHandle,productId:this.productId ,variantId:this.variantId} })
      document.dispatchEvent(removeEvent);
    })
  }
}
customElements.define('cart-item-remove',RemoveBtn)

// login toggle
class LoginToggle extends HTMLElement{
  constructor(){
    super()
    this.addEventListener('click',(e)=>{
      e.preventDefault();
      let loginForm = document.querySelector('login-form');
      if(loginForm.classList.contains("show")){
        loginForm.classList.remove("show");
        setTimeout(()=>{
          loginForm.style.display = 'none';
        },300)
        
        
      }else{
        
        loginForm.style.display = 'block';
        setTimeout(()=>{loginForm.classList.add("show");},0)
      } 
    })
  }
}
customElements.define("login-toggle",LoginToggle);
// login form
class LoginForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.emailInput = this.querySelector('input[name="customer[email]"]');
    this.passwordInput = this.querySelector('input[name="customer[password]"]');
    this.errorField = this.querySelector('[data-role="error-field"]');
    this.submissionButton = this.querySelector('button[type="submit"]');
    this.form.addEventListener("submit", this.formSubmission.bind(this));
    this.emailInput.addEventListener("input", this.emailValid.bind(this));
    this.passwordInput.addEventListener("input", this.passValid.bind(this));
    /// on foucus out error
    this.emailInput.addEventListener("focusout", () => {
      this.emailValidation
        ? this.emailInput.classList.remove("error")
        : this.emailInput.classList.add("error");
    });
    this.passwordInput.addEventListener("focusout", () => {
      this.passValidation
        ? this.passwordInput.classList.remove("error")
        : this.passwordInput.classList.add("error");
    });
  }
  emailValid() {
    let emailRegex =
      /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    let emailValue = this.emailInput.value;
    emailRegex.test(emailValue)
      ? (this.emailValidation = true)
      : (this.emailValidation = false);
    this.emailValidation
      ? this.emailInput.classList.remove("error")
      : this.emailInput.classList.add("error");
    this.emailValidation && this.passValidation
      ? this.submissionButton.removeAttribute("disabled")
      : this.submissionButton.setAttribute("disabled", "disabled");
  }
  passValid() {
    let passValue = this.passwordInput.value;
    passValue.trim().length < 1
      ? (this.passValidation = false)
      : (this.passValidation = true);
    this.passValidation
      ? this.passwordInput.classList.remove("error")
      : this.passwordInput.classList.add("error");
    this.emailValidation && this.passValidation
      ? this.submissionButton.removeAttribute("disabled")
      : this.submissionButton.setAttribute("disabled", "disabled");
  }
  // form submission
  formSubmission(e) {
    e.preventDefault();
    this.classList.add("loading");
    let formData = new URLSearchParams(new FormData(this.form)).toString();
    fetch(this.form.action, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData,
    })
      .then((res) => res.text())
      .then((htmlText) => {
        let parser = new DOMParser();
        let loginHtml = parser.parseFromString(htmlText, "text/html");
        let errors = loginHtml.querySelector('[data-role="errors"]');
        if (errors) {
          this.errorField.classList.remove("hidden");
          this.classList.remove("loading");
        } else {
          this.classList.remove("loading");
          this.errorField.classList.add("hidden");
          this.classList.add("success");
          setTimeout(() => {
            window.location.href = "/cart";
          }, 500);
        }
        errors ? console.log("errors", errors) : console.log("no errors found");
      });
  }
}
customElements.define("login-form", LoginForm);

/////// You may also like slider
initSlider();
function initSlider(){

function navigation(slider) {
  let wrapper, arrowLeft, arrowRight;

  const observer = new ResizeObserver(function () {
    slider.update();
  });

  function markup(remove) {
    wrapperMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(elment) {
    elment.parentNode.removeChild(elment);
  }
  function createDiv(className) {
    var div = document.createElement("div");
    var classNames = className.split(" ");
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);
      return;
    }
    arrowLeft = createDiv("arrow arrow--left");
    arrowLeft.addEventListener("click", () => slider.prev());
    arrowRight = createDiv("arrow arrow--right");
    arrowRight.addEventListener("click", () => slider.next());

    wrapper.appendChild(arrowLeft);
    wrapper.appendChild(arrowRight);
  }

  function wrapperMarkup(remove) {
    if (remove) {
      var parent = wrapper.parentNode;
      while (wrapper.firstChild)
        parent.insertBefore(wrapper.firstChild, wrapper);
      removeElement(wrapper);
      return;
    }
    wrapper = createDiv("navigation-wrapper");
    slider.container.parentNode.appendChild(wrapper);
    wrapper.appendChild(slider.container);
  }

  function updateClasses() {
    var slide = slider.track.details.rel;
    slide === 0
      ? arrowLeft.classList.add("arrow--disabled")
      : arrowLeft.classList.remove("arrow--disabled");
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add("arrow--disabled")
      : arrowRight.classList.remove("arrow--disabled");
  }

  slider.on("created", () => {
    markup();
    updateClasses();
    observer.observe(slider.container);
    hidePlaceholder(true);
  });
  slider.on("optionsChanged", () => {
    markup(true);
    markup();
    updateClasses();
  });
  slider.on("slideChanged", () => {
    updateClasses();
  });
  slider.on("destroyed", () => {
    markup(true);
    observer.unobserve(slider.container);
  });
}
var sliderEle = document.querySelector("#pc-slider");
//let rtlView = window.Shopify.locale == "ar" ? true : false;
if (sliderEle) {
  var slider = new KeenSlider(
    "#pc-slider",
    {
      loop: true,
      rtl: rtlView,
      slides: {
        spacing: 10,
        perView: 2.3,
      },
      breakpoints: {
        "(min-width: 768px)": {
          slides: {
            perView: 5,
            spacing: 24,
          },
        },
        "(min-width: 1200px)": {
          slides: {
            perView: 5,
            spacing: 64,
          },
        },
      },
    },
    [navigation]
  );
}

function hidePlaceholder(action) {
  if (action) {
    let placeholderEle = document.querySelector("#pc-placeholder");
    let sliderEle = document.querySelector("#pc-slider");
    placeholderEle.classList.add("hide");
    sliderEle.classList.remove("hide");
  }
}
}
/// item remove popup dialog box

class ItemRemovePopup extends HTMLElement{
  constructor(){
    super()
    let deleteBtn = this.querySelector('[data-role="delete"]');
    this.closeBtn = this.querySelector('[data-role="remove-popupDisplay"]');
    this.wishlistBtn = this.querySelector("wishlist-btn");
    this.overlay = document.querySelector('[data-role="remove-popup-overlay"]');
    this.deleteKey;

    document.addEventListener('remove-item',this.poupDisplay.bind(this));
    document.addEventListener('remove-item',this.updateWishlistButton.bind(this));
    deleteBtn.addEventListener('click',this.confirmDelete.bind(this));
    this.overlay.addEventListener('click',this.hidePopup.bind(this))
    this.closeBtn.addEventListener('click',this.hidePopup.bind(this))
    this.wishlistBtn.addEventListener('click',this.addToWishlist.bind(this))
  }
  updateWishlistButton(e){
    this.wishlistBtn.dataset.variantId = e.detail.variantId;
    this.wishlistBtn.dataset.productId = e.detail.productId;
    this.wishlistBtn.dataset.productHandle = e.detail.handle;
    this.deleteKey = e.detail.key;
  }
  addToWishlist(){
    let event =  new CustomEvent('remove-itemConfirm', { detail: {key:this.deleteKey} });
    document.dispatchEvent(event);
    this.hidePopup();
  }
  poupDisplay(e){
    this.deleteKey = e.detail.key;
    this.classList.remove('hidden');
    document.body.style.overflowY = 'hidden';
    setTimeout(()=>{
      this.style.opacity = '1';
      this.overlay.style.opacity = '1';
    },0)
  }
  hidePopup(){
    this.style.opacity = '0';
    this.overlay.style.opacity = '0';
    document.body.style.overflowY = 'auto';
    setTimeout(()=>{
      this.classList.add('hidden');
    },0)
  }
  confirmDelete(e){
    let event =  new CustomEvent('remove-itemConfirm', { detail: {key:this.deleteKey} });
    document.dispatchEvent(event);
    this.hidePopup();
  }
}
customElements.define("item-remove-popup",ItemRemovePopup);